import React from 'react';
import { Play } from 'lucide-react';

const VideoPlaceholder = ({ label = 'VIDEO', src, poster, caption }) => {
    if (src) {
        return (
            <section className="relative w-full bg-[#0A0A14]">
                <div className="relative aspect-video w-full overflow-hidden">
                    <video
                        src={src}
                        poster={poster}
                        autoPlay
                        muted
                        loop
                        playsInline
                        controls
                        className="w-full h-full object-cover"
                    />
                </div>
            </section>
        );
    }

    return (
        <section className="relative w-full bg-[#0A0A14]">
            <div className="relative aspect-video w-full overflow-hidden bg-[#18181B] border-y border-[#7B61FF]/20 flex items-center justify-center">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(123,97,255,0.08),transparent_60%)] pointer-events-none" />
                <div className="relative z-10 flex flex-col items-center gap-5 text-center px-6">
                    <div className="w-20 h-20 rounded-full bg-[#7B61FF]/10 border border-[#7B61FF]/30 flex items-center justify-center">
                        <Play size={28} className="text-[#7B61FF] translate-x-[2px]" />
                    </div>
                    <p className="font-data text-[#7B61FF] text-xs tracking-widest uppercase">
                        {label}
                    </p>
                    {caption ? (
                        <p className="text-[#F0EFF4]/40 text-sm max-w-md">{caption}</p>
                    ) : null}
                </div>
            </div>
        </section>
    );
};

export default VideoPlaceholder;
